<template>
  <div class="error-page">
    <ErrorCard :error="$t('pages.notFound.error')" />
  </div>
</template>

<script>
import ErrorCard from "@/pages/notFound/ErrorCard";
import { headMetaTags } from "@/utils/headMetaTags";

export default {
  name: "NotFoundPage",
  components: {
    ErrorCard
  },
  metaInfo() {
    return {
      title: this.$t("pages.notFound.title"),
      meta: headMetaTags({
        title: this.$t("pages.notFound.title"),
        description: this.$t("pages.notFound.description"),
        url: location.href
      })
    };
  }
};
</script>
<style scoped>
.error-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
